"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ParameterBase_1 = require("./ParameterBase");
const MultiplicityType_1 = require("./MultiplicityType");
class MultiValueParameter extends ParameterBase_1.ParameterBase {
    constructor(id, type, allowNullable, initalValue, handleChange) {
        super(id, type, allowNullable, handleChange);
        this.value = initalValue;
    }
    get multiplicityType() {
        return MultiplicityType_1.MultiplicityType.Multiple;
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (!this.allowNullable && val === undefined) {
            throw `Cannot assign null to non-nullable parameter ${this.id}`;
        }
        const isValueNull = this.allowNullable && val === undefined;
        if (!isValueNull) {
            const isValuesAreValid = Array.isArray(val) && val.every((x) => this._isValueValid(x));
            if (!isValuesAreValid) {
                throw `Invald value type from parameter ${this.id}`;
            }
        }
        this._value = val;
        // raise property changed
        this._onPropertyChange(this.id, this.value);
    }
}
exports.MultiValueParameter = MultiValueParameter;
//# sourceMappingURL=MultiValueParameter.js.map